import { AUTHENTICATION_SERVICE_URL } from '@/lib/constants/api';
import { apiFetch } from '@/lib/utils/apiFetch';
import type {
  ApiKeyListResponse,
  CreateApiKeyPayload,
  CreateApiKeyResponse,
} from './types';

export async function fetchApiKeys(qs: string): Promise<ApiKeyListResponse> {
  return apiFetch<ApiKeyListResponse>(
    `/v1/api-key?${qs}`,
    {},
    AUTHENTICATION_SERVICE_URL,
  );
}

export async function createApiKey(
  payload: CreateApiKeyPayload,
): Promise<CreateApiKeyResponse> {
  return apiFetch<CreateApiKeyResponse>(
    '/v1/api-key',
    {
      method: 'POST',
      body: JSON.stringify(payload),
    },
    AUTHENTICATION_SERVICE_URL,
  );
}

export async function deleteApiKey(label: string): Promise<void> {
  return apiFetch<void>(
    '/v1/api-key',
    {
      method: 'DELETE',
      body: JSON.stringify({ label }),
    },
    AUTHENTICATION_SERVICE_URL,
  );
}
